export default "__VITE_ASSET__DIuNSGx7__"